<div class="justify-content-center py-5">
    <app-loading-icon ></app-loading-icon>
</div>
